// src/components/QuizList.jsx
import React, { useState } from "react";

export function QuizList({
  quizzes,
  quizPage,
  quizzesPerPage,
  onTake,
  onEdit,
  onDelete,
  onPageChange,
}) {
  const [search, setSearch] = useState("");

  // Filter quizzes by name (case-insensitive)
  const filteredQuizzes = quizzes.filter((q) =>
    q.name.toLowerCase().includes(search.toLowerCase())
  );

  // Pagination based on filtered list
  const totalPages = Math.max(1, Math.ceil(filteredQuizzes.length / quizzesPerPage));
  const start = (quizPage - 1) * quizzesPerPage;
  const pageItems = filteredQuizzes.slice(start, start + quizzesPerPage);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    // reset to first page whenever the filter changes
    onPageChange(1);
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-md space-y-6">
      <div className="flex items-center justify-between gap-4">
        <h2 className="text-xl font-semibold text-gray-700">Your Quizzes</h2>

        {/* Search box */}
        <input
          type="text"
          value={search}
          onChange={handleSearchChange}
          placeholder="Search quizzes..."
          className="border px-3 py-1 rounded text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
        />
      </div>

      <ul className="space-y-3">
        {pageItems.length === 0 && (
          <li className="text-gray-500 text-sm italic">
            {search
              ? `No quizzes found matching “${search}”.`
              : "You have no quizzes yet."}
          </li>
        )}

        {pageItems.map((q) => (
          <li
            key={q.id}
            className="flex items-center justify-between bg-gray-100 px-4 py-3 rounded-md shadow-sm hover:shadow-md transition"
          >
            <span className="text-lg font-medium text-gray-800">{q.name}</span>
            <div className="flex gap-2">
              <button
                onClick={() => onTake(q)}
                className="bg-indigo-600 text-white px-4 py-1.5 rounded hover:bg-indigo-700 transition"
              >
                Take Quiz
              </button>
              <button
                onClick={() => onEdit(q)}
                className="bg-blue-500 text-white px-2 py-1 text-sm rounded hover:bg-blue-600 transition"
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(q.id)}
                className="bg-red-500 text-white px-2 py-1 text-sm rounded hover:bg-red-600 transition"
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>

      {/* Pagination */}
      {filteredQuizzes.length > 0 && (
        <div className="flex justify-center items-center space-x-2">
          <button
            onClick={() => onPageChange(quizPage - 1)}
            disabled={quizPage === 1}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Prev
          </button>
          <span className="text-sm font-medium">
            Page {quizPage} of {totalPages}
          </span>
          <button
            onClick={() => onPageChange(quizPage + 1)}
            disabled={quizPage === totalPages}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
